<template>
  <div
    class="raffle__footer"
  >
    <button
      class="btn btn--primary btn--shadow"
      :class="{ 'btn--loading': isLoading }"
      @click="register"
    >
      {{ $t('raffle.btn-signup-play') }}
    </button>
<!--    <button
      class="link text-xs font-bold pt-4"
      @click="login"
    >
      {{ $t('raffle.btn-login') }}
    </button>-->
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
  isLoading: {type: Boolean, required: false, default: false},
})

const emits = defineEmits(['login','register'])

const login = () => {
  emits('login')
}

const register = () => {
  emits('register')
}
</script>

<style scoped>
</style>
